// extracted by mini-css-extract-plugin
export default {"btn_theme_switcher":"ThemeSwitcher_btn_theme_switcher__e-7Y1"};